import { startOfDay } from 'date-fns/startOfDay';

import { DEPARTURE_TIME_BOUNDARIES_MINUTES } from '../constants/departureTimeConstants';

import { formatTimeBucketRange } from './formatTimeBucketRange';

import type { DepartureTime } from '../constants/departureTimeConstants';

type Localisation = {
  formatTime(date: Date): string;
};

// setMinutes overflows into hours using local wall-clock rollover (not
// elapsed real time like addMinutes/addHours), so this stays DST-safe.
const minutesToTime = (minutes: number): Date => {
  const date = startOfDay(new Date());
  date.setMinutes(minutes);
  return date;
};

export const formatDepartureTimeRange = (
  time: DepartureTime,
  localisation: Localisation,
): string => {
  const { end, start } = DEPARTURE_TIME_BOUNDARIES_MINUTES[time]; // minutes since midnight
  return formatTimeBucketRange(
    minutesToTime(start),
    minutesToTime(end),
    localisation,
  );
};
